import { PersistedOrder } from '@features/orders/persisted-order';
import { buildOrderAssetProduct } from './build-order-asset-product';
import { EcommerceEvent } from './ecommerce-event-enum';
import { IOrderPlacement } from './i-order-placement';

export function buildOrderPlacement(order: PersistedOrder): IOrderPlacement {
  return {
    event: EcommerceEvent.Checkout,
    ecommerce: {
      checkout: {
        actionField: { step: 2, option: order.purpose },
        dimension10: order.flow,
        products: order.assets.map(buildOrderAssetProduct),
      },
    },
  };
}
